import APITemplate from './APITemplate'

export default APITemplate('/company')
